import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import { RoomLayout } from "./pages/RoomLayout";
import { NotFound } from "./pages/NotFound";
import { pages } from "./content";
import { queryClient } from "./lib/queryClient";
import { ThemeProvider } from "./lib/theme";
import "./styles.css";

const router = createBrowserRouter([
  {
    // Lazy-loaded so the Cognito SDK chunk only downloads when needed.
    path: "/login",
    lazy: async () => {
      const mod = await import("./pages/Login");
      return { Component: mod.Login };
    },
  },
  {
    // Lazy-loaded admin chunk — investors never download admin code.
    path: "/admin",
    lazy: async () => {
      const mod = await import("./admin");
      return { Component: mod.AdminGate };
    },
    children: [
      { index: true, element: <Navigate to="users" replace /> },
      {
        path: "users",
        lazy: async () => {
          const mod = await import("./admin");
          return { Component: mod.UsersList };
        },
      },
      {
        path: "users/:username",
        lazy: async () => {
          const mod = await import("./admin");
          return { Component: mod.UserDetail };
        },
      },
    ],
  },
  {
    path: "/",
    element: <RoomLayout />,
    children: pages.map(({ slug, Component }) => ({
      path: slug || undefined,
      index: slug === "",
      element: <Component />,
    })),
  },
  { path: "*", element: <NotFound /> },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
